import CustomBlockButton from "../../../../../components/button/CustomBlockButton";
import styled from 'styled-components';
import { useQueryParamsHook } from "../../../../../utils/useQueryParamsHook";
import { useSelectedCommerceApiStoreInfosValueContextHook } from "../../contexts/SelectedCommerceApiStoreInfosContext";
import { ViewType } from "../../variables/ViewType";
import { CommerceApiApi } from "../../../../../apis/CommerceApiApi";
import { useApiInfoContextValueHook } from "../../../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../../../utils/sellertool-signature-utils";
import { CustomBackdropController } from "../../../../../components/backdrop/default/v1";
import { customToast } from "../../../../../components/toast/custom-react-toastify/v1";
import { useNavigate } from "react-router-dom";
import { useCollectedOrderDatasActionsContextHook } from "../../contexts/CollectedOrderDatasContext";

const Container = styled.div`
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const StyledButton = styled(CustomBlockButton)`
    background-color: #333;
    color: #fff;
    font-weight: 600;
    border-radius: 3px;

    &.collected{
        background: #fff;
        color: #333;
        border-color: #333;
    }
`;


export function WegetCollectionButton(props) {
    const navigate = useNavigate();
    const queryParamsHook = useQueryParamsHook();
    const selectedCommerceApiStoreInfosValueContextHook = useSelectedCommerceApiStoreInfosValueContextHook();
    const collectedOrderDatasActionsContextHook = useCollectedOrderDatasActionsContextHook();

    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const handleFulfillCollection = async () => {
        if (selectedCommerceApiStoreInfosValueContextHook.commerceApiStoreInfos?.length <= 0) {
            customToast.error('주문수집할 스토어를 선택해주세요.');
            return;
        }

        queryParamsHook.setSearchParams({ ViewType: ViewType.COLLECTED }, { replace: false });

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            commerceApiStoreInfoIds: selectedCommerceApiStoreInfosValueContextHook.commerceApiStoreInfos.map(storeInfo => storeInfo.id)
        }

        CustomBackdropController().showBackdrop();
        const result = await CommerceApiApi().collectOrders({ body: body, headers: headers });
        if (!result?.content) {
            navigate(-1);
        }
        if (result?.content) {
            collectedOrderDatasActionsContextHook.collectedOrderDatas.onSet(result?.content);
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleMoveToCollected = () =>{
        queryParamsHook.setSearchParams({ ViewType: ViewType.COLLECTED }, { replace: false });
    }

    return (
        <>
            <Container>
                <StyledButton
                    type='button'
                    onClick={() => handleFulfillCollection()}
                >
                    주문수집
                </StyledButton>
                <StyledButton
                    type='button'
                    onClick={() => handleMoveToCollected()}
                    className='collected'
                >
                    수집현황
                </StyledButton>
            </Container>
        </>
    );
}